import { QueryKey, useQueryClient } from '@taxdown/zeno-sama-query';

export function useGetQuery<T>(queryKey: QueryKey): T | undefined {
  const queryCache = useQueryClient();
  const data = queryCache.getQueryData<T>(queryKey);
  return data;
}
